import "./FAQ.module.css";
import Header from "@/reusable_sections/Header";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function DetailsPage() {
  return <div>
      <Header />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}